<template>
  <div class="teamBuilding" ref="teamBuildingRef" >
    <heads></heads>
    <div class="container" ref="containerRef">
      <div class="content">
        <!--搜索区-->
        <div class="content-top" ref="contentTopRef">
          <div class="search-wrapper">
            <div class="search-input-wrapper">
              <input
                type="text"
                class="search-input"
                v-model="searchVal"
                @keyup.enter="toSearch"
                placeholder="您可以输入产品名称或目的地快速上搜索"
              />
              <div class="search-btn" @click="toSearch">
                <span class="el-icon-search"></span>
                搜索
              </div>
            </div>
          </div>
          <div class="search-select-item">
            <span class="select-sider">团建目的地</span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="selectTargetPlace(-1)"
                  :class="targetPlaceNum == -1 ? 'select' : ''"
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in targetPlace"
                  :key="index"
                  @click="selectTargetPlace(index)"
                  :class="targetPlaceNum == index ? 'select' : ''"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <!-- <div class="close-open">展开</div> -->
          </div>
          <div
            class="select-items search-select-item"
            v-if="placeContentArray.length > 0"
          >
            <span class="select-sider"></span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="placeSimpleSelect(-1, -1)"
                  :class="placeSelectContain(-1, -1) ? 'select' : ''"
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in placeContentArray"
                  :key="index"
                  @click="placeSimpleSelect(targetPlaceNum, item.id)"
                  :class="
                    placeSelectContain(targetPlaceNum, item.id) ? 'select' : ''
                  "
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <!-- <div class="close-open">展开</div> -->
          </div>
          <div class="search-select-item">
            <span class="select-sider">团建玩法</span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="playSelect(-1)"
                  :class="playSelectIndex == -1 ? 'select' : ''"
                >
                  不限
                </li>
                <li
                  v-for="item in playList"
                  :key="item.playTypeId"
                  @click="playSelect(item)"
                  :class="playSelectIndex == item.playTypeId ? 'select' : ''"
                >
                  {{ item.playTypeName }}
                </li>
              </ul>
            </div>
            <!-- <div class="close-open">展开</div> -->
          </div>
          <div
            class="select-items search-select-item"
            v-if="playSecondList && playSecondList.length > 0"
          >
            <span class="select-sider"></span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="playMoreSelect(-1)"
                  :class="
                    selectContains(playSelectIndexList, -1) ? 'select' : ''
                  "
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in playSecondList"
                  :key="index"
                  @click="playMoreSelect(item)"
                  :class="
                    selectContains(playSelectIndexList, item.playId)
                      ? 'select'
                      : ''
                  "
                >
                  {{ item.playName }}
                </li>
              </ul>
            </div>
            <!-- <div class="close-open">展开</div> -->
          </div>
          <div class="search-select-item"></div>
          <div class="search-select-item">
            <span class="select-sider">团建收益</span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="profitMoreSelect()"
                  :class="
                    selectContains(profitSelectIndexList, -1) ? 'select' : ''
                  "
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in profitList"
                  :key="index"
                  @click="profitMoreSelect(item)"
                  :class="
                    selectContains(profitSelectIndexList, item.profitId)
                      ? 'select'
                      : ''
                  "
                >
                  {{ item.profitName }}
                </li>
              </ul>
            </div>
            <!-- <div class="close-open">展开</div> -->
          </div>
          <div class="search-select-item">
            <span class="select-sider">团建天数</span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="daySimpleSelect()"
                  :class="daySelectId == -1 ? 'select' : ''"
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in dayList"
                  :key="index"
                  @click="daySimpleSelect(item)"
                  :class="daySelectId == item.id ? 'select' : ''"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="search-select-item">
            <span class="select-sider">团建类型</span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="earningsMoreSelect(earningsSelectList, -1)"
                  :class="
                    selectContains(earningsSelectList, -1) ? 'select' : ''
                  "
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in profitList"
                  :key="index"
                  @click="earningsMoreSelect(earningsSelectList, index)"
                  :class="
                    selectContains(earningsSelectList, index) ? 'select' : ''
                  "
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="close-open">展开</div>
          </div> -->
        </div>
        <div class="content-bottom">
          <!--列表区-->
          <div class="building-list" ref="buildingListRef">
            <div>
              <!-- <div
                class="building-list-selections"
                ref="buildingListSelectionsRef"
              >
                <span class="selection-sider">你已选择:</span>
                <div class="selection-item">
                  <ul>
                    <li>
                      <span class="txt">团结队伍</span
                      ><span class="remove">×</span>
                    </li>
                    <li id="sort-result-clear">全部清除</li>
                  </ul>
                </div>
              </div> -->
              <div class="building-list-sort" ref="buildingListSortRef">
                <ul>
                  <li
                    @click="changeSortRule(1)"
                    :class="selectSort == 1 ? 'select' : ''"
                  >
                    默认排序
                  </li>
                  <li
                    @click="changeSortRule(2)"
                    class="sortTag"
                    :class="selectSort == 2 ? 'select' : ''"
                  >
                    价格<span
                      v-if="selectSort == 2"
                      :class="
                        priceSort == 1
                          ? 'el-icon-caret-top'
                          : (priceSort == 2?'el-icon-caret-bottom':'')
                      "
                    ></span>
                  </li>
                </ul>
              </div>
              <div class="building-list-content">
                <div
                  class="building-list-content-item"
                  v-for="item in pageArray"
                  :key="item.id"
                  @click="toDetail(item.id)"
                >
                  <div class="buiiding-list-left">
                    <img :src="getPreUrl + item.image" />
                  </div>
                  <div class="buiiding-list-middle">
                    <div class="title">
                      {{ item.title }}
                    </div>
                    <div class="tags" v-if="item.profitList">
                      <span
                        v-for="(item, index) in item.profitList"
                        :key="index"
                        >{{ item }}</span
                      >
                    </div>
                    <div class="type">
                      <span v-if="item.typeName">{{ item.typeName }}</span
                      ><span class="separator" v-if="item.typeName && item.day"
                        >|</span
                      ><span v-if="item.day"
                        >{{ item.day }}天{{ item.night }}晚</span
                      ><span
                        class="separator"
                        v-if="item.numberMin || item.numberMax"
                        >|</span
                      ><span v-if="item.numberMin || item.numberMax"
                        >{{ item.numberMin }}-{{ item.numberMax }}人</span
                      >
                    </div>
                    <div class="destination">{{ item.destinationName }}</div>
                  </div>
                  <div class="buiiding-list-right">
                    <div class="exponents">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="餐饮指数"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.eatIndex > 3">
                          <i class="fa fa-coffee"></i>
                          <el-rate
                            v-model="item.eatIndex"
                            :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                          <!-- void-icon-class="el-icon-minus" -->
                          <!-- :icon-classes="iconClasses" -->
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="团建项目"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.teamIndex > 3">
                          <i class="fa fa-users"></i>
                          <el-rate
                            v-model="item.teamIndex"
                            :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="体力消耗"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.energyIndex > 0">
                          <i class="fa fa-rocket"></i>
                          <el-rate
                            v-model="item.energyIndex"
                            :colors="['#18d3a0', '#18d3a0', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="景区风光"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.viewIndex > 3">
                          <i class="fa fa-university"></i>
                          <el-rate
                            v-model="item.viewIndex"
                            :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="price">{{ item.price }}</div>
                    <div class="avg-pirce">{{ item.numberMin }}人均价</div>
                  </div>
                </div>
                <div class="pagination">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageNum"
                    :page-size="pageSize"
                    :total="total"
                  ></el-pagination>
                </div>
              </div>
            </div>
            <div></div>
            <!--定制方案区-->
            <div
              class="free-booking"
              ref="freeBookingRef"
              :class="
                freeBookingStyle == 1 ? 'free-booking-1' : 'free-booking-2'
              "
              :style="freeBookingStyle == 2 ? { top: topHeight } : ''"
            >
              <!-- <div class="free-booking-header">
                <span class="free-booking-dot"></span>
                <span class="free-booking-title">免费定制方案</span>
                <span class="free-booking-dot"></span>
              </div>
              <div class="free-booking-item">
                <span class="txt">出行人数</span>
                <el-select v-model="form.peopleNumber" placeholder="出行人数">
                  <el-option
                    v-for="(item, index) in getRequirementType.travelNumberType"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="free-booking-item">
                <span class="txt">人均预算</span>
                <el-select v-model="form.avgPrice" placeholder="人均预算">
                  <el-option
                    v-for="(item, index) in getRequirementType.avgBudgetType"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="free-booking-item">
                <span class="txt">团建天数</span>
                <el-select v-model="form.activityDay" placeholder="团建天数">
                  <el-option
                    v-for="(item, index) in getRequirementType.dayType"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="free-booking-item free-booking-item2">
                <span class="txt">联系人</span>
                <el-input
                  v-model="form.contact"
                  placeholder="联系人"
                  style="display: inline"
                ></el-input>
              </div>
              <div class="free-booking-item free-booking-item2">
                <span class="txt request">联系电话</span>
                <el-input
                  v-model="form.mobile"
                  placeholder="联系电话"
                  style="display: inline"
                ></el-input>
              </div>
              <div class="free-booking-item">
                <span class="txt request">验证码</span>
                <div class="sendCode">
                  <el-input
                    v-model="form.verificationCode"
                    placeholder="4位验证码"
                    style="display: inline"
                  ></el-input>
                  <span
                    class="txt2"
                    :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                    @click="sendSMS"
                    >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span
                  >
                </div>
              </div>
              <div class="free-booking-item free-booking-item2">
                <span class="txt">微信号</span>
                <el-input
                  v-model="form.wxNumber"
                  placeholder="微信号"
                  style="display: inline"
                ></el-input>
              </div>
              <div class="element-row">
                <div class="free-booking-item">
                  <div
                    class="
                      tool-button
                      free-booking-item-order-submit
                      tool-button-primary
                    "
                  >
                    <button @click="submit">提交团建需求</button>
                  </div>
                </div>
              </div> -->
              <img src="../../../static/images/customizedTipRight.png" @click="goToCustomPage" class="customized-tip"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
    <homeBottomImage style="z-index:1000"></homeBottomImage>
    <quickContact :message="quickContactMessage"></quickContact>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate, handlePic, isPhoneNumber } from "@/util/util.js";
import quickContact from "@/components/comment/quickContact.vue";
import wxShare from "@/common/wx_share.js";
import axios from "axios";
export default {
  name: "teamBuilding",
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      nav: 0,
      freeBookingStyle: 2,
      topHeight: "400px",
      iconClasses: ["el-icon-minus"],
      smsCodeTime: 0,
      // 提交表单
      form: {
        peopleNumber: "",
        avgPrice: "",
        teamBuildingDay: "",
        contact: "",
        mobile: "",
        verificationCode: "",
        wxNumber: "",
        description: "",
      },
      // 团建选择天数
      daySelectId: -1,
      // 团建选择天数类型
      searchDayType: null,
      quickContactMessage: {
        type: 1,
      },
      // 排序规则
      priceSort:-1,
      // 1.过滤条件搜索 2.搜索框搜索
      searchMode:1,
      // 团建天数
      dayList: [
        {
          dayType: 1,
          name: "一天",
          id: 1,
        },
        {
          dayType: 2,
          name: "两天",
          id: 2,
        },
        {
          id: 3,
          dayType: 3,
          name: "三天",
        },
        {
          id: 4,
          dayType: 4,
          name: "四天以上",
        },
      ],
      targetPlace: [
        {
          id: 1,
          name: "本市行政区",
          child: [],
        },
        {
          id: 2,
          name: "省内城市",
          child: [],
        },
        {
          id: 3,
          name: "国内城市",
          child: [],
        },
        {
          id: 4,
          name: "国际长线",
          child: [],
        },
      ],
      // 团建收益扩展列
      profitExpandList: [],
      // 团建收益选中
      profitSelectIndexList: [-1],
      // 团建收益列表
      profitList: [],
      // 团建玩法选中
      playSelectIndex: -1,
      playSelectIndexList: [-1],
      playExpandList: [],
      // 团建玩法二级
      playSecondList: [],
      tbTypeId: -1,
      // 团建玩法
      playList: [],

      // 提交表单
      form: {
        travelNumber: "",
        avgBudget: "",
        teamBuildingDay: "",
        contact: "",
        mobile: "",
        verificationCode: "",
        wxNumber: "",
        description: "",
      },
      // --
      activeIndex: 0,
      title: "",
      subjectId: 54,
      pageArray: [],
      loading: false,
      searchVal: "",
      selectList: {},
      priceSort: "",
      selectSort: 1,

      // 团建目的地相关字段
      scenicSpotsList: [],
      // 省内城市
      surroundCityList: [],
      // 国际长线
      foreignCityList: [],
      // 国内城市
      domesticCityList: [],
      
      regionList: [],

      targetPlaceNum: -1,
      placeContentArray: [],
      placeSelectIndex: {
        typeNumber: -1,
        id: -1,
      },
      searchCityId: null,
      searchScenicSpotsId: null,
      searchRegionId: null,
      destinationId: null,
      placeSecondList: [],
    };
  },
  components: {
    heads,
    homeFoots,
    banners,
    quickContact,
    homeBottomImage
  },
  computed: {
    getPreUrl() {
      return this.$store.state.picPreUrl;
    },
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity;
    },
    getRequirementType() {
      return this.$store.state.requirementTypeData;
    },
  },
  watch: {},
  methods: {
    isPhoneNumber,
    fomateDate,
    handlePic,
    // 去定制页面
    goToCustomPage(){
      window.open("/#/custom");
    },
    toDetail(id) {
      window.open("/#/teamBuildingDetail?id="+id)
    },
    // -- 分页方法
    handleCurrentChange(val) {
      this.loading = true;
      this.dispatchQuery();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    clearForm() {
      // 提交表单
      this.form = {
        peopleNumber: null,
        avgPrice: null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      };
    },
    // 发送短信
    sendSMS() {
      if (this.smsCodeTime > 0 || !isPhoneNumber(this.form.mobile)) {
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { mobile, verificationCode } = this.form;
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      this.form.type = "1";
      let params = this.form;
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
              if (res.data.msg) {
                msg = res.data.msg;
              } else {
                msg = "需求提交成功";
              }
              this.$message({
                message: msg,
                type: "success",
                center: true,
              });
              this.clearForm();
            } else {
              if (res.data.code == 500) {
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 查询调度方法
    async dispatchQuery(){
      if(this.searchMode == 1){
        await this.getTbPage();
      }else{
        await this.getSearchTbPage();
      }
    },
    // -- 分页方法
    getSearchTbPage() {
      if (this.searchVal) {
        this.tbTypeId = null;
        this.destinationId = null;
      }
      if (this.destinationId) {
        this.tbTypeId = null;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title: this.searchVal,
        typeIds: this.tbTypeId,
        destinationId: this.destinationId,
        priceSort:this.priceSort,
        departCityId:this.getLocationSiteCityId?this.getLocationSiteCityId:5,
        tbType: "1",
      };
      axios
        .get(`/api/tb/tbList`, {
          params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.pageArray = res.data.rows;
            this.total = res.data.total;
            this.pageArray.forEach((tb) => {
              if (tb.profitNames) {
                let profitList = tb.profitNames.split(" ");
                tb.profitList = profitList;
              }
              if (tb.typeNames) {
                let typeNameList = tb.typeNames.split(" ");
                tb.typeName = typeNameList[0];
              }
              if (tb.image) {
                let imageList = handlePic(tb.image);
                if (imageList != null && imageList.length > 0) {
                  tb.image = imageList[0];
                }
              }
            });
            this.loading = false;
          }
        });
        this.wxShareForTeamBuilding();
    },
    // -- 分页方法
    getTbPage() {
      let playTypeId = this.playSelectIndex != -1 ? this.playSelectIndex : null;
      let profitIds = "";
      this.profitSelectIndexList.forEach((profit) => {
        if (profit != -1) {
          if (profitIds != "") {
            profitIds += "," + profit;
          } else {
            profitIds = profit;
          }
        }
      });
      if (profitIds == "") {
        profitIds = null;
      }
      let playIds = "";
      this.playSelectIndexList.forEach((play) => {
        if (play != -1) {
          if (playIds != "") {
            playIds += "," + play;
          } else {
            playIds = play;
          }
        }
      });
      if (playIds == "") {
        playIds = null;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        dayType: this.searchDayType,
        profitIds: profitIds,
        cityId: this.searchCityId,
        departCityId:this.getLocationSiteCityId?this.getLocationSiteCityId:5,
        spotsId: this.searchScenicSpotsId,
        regionId: this.searchRegionId,
        playTypeId: playTypeId,
        playIds: playIds,
        priceSort:this.priceSort,
        tbType: "1",
      };
      axios
        .get(`/api/tb/tbList`, {
          params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.pageArray = res.data.rows;
            this.total = res.data.total;
            this.pageArray.forEach((tb) => {
              if (tb.profitNames) {
                let profitList = tb.profitNames.split(" ");
                tb.profitList = profitList;
              }
              if (tb.typeNames) {
                let typeNameList = tb.typeNames.split(" ");
                tb.typeName = typeNameList[0];
              }
              if (tb.image) {
                let imageList = handlePic(tb.image);
                if (imageList != null && imageList.length > 0) {
                  tb.image = imageList[0];
                }
              }
            });
            this.loading = false;
          }
        });
        this.wxShareForTeamBuilding();
    },

    toSearch() {
      this.loading = true;
      this.searchMode = 2;
      this.getSearchTbPage();
    },

    // 改变分页排序规则
    changeSortRule(val) {
      if (this.selectSort == val && val == 1) {
        this.priceSort = -1;
        return;
      }
      this.selectSort = val;
      if (val == 2) {
        if (this.priceSort == 2) {
          this.priceSort = 1;
        } else {
          this.priceSort = 2;
        }
      } else {
        this.priceSort = -1;
      }
      // 分页条件重置
      this.dispatchQuery();
      // 搜索
    },
    // 判断数组是否包含
    selectContains(array, index) {
      // debugger
      console.log("---|---");
      return array.indexOf(index) > -1 ? true : false;
    },
    // 正式时要分开
    // 天数单选
    daySimpleSelect(item) {
      if (item) {
        this.searchDayType = item.dayType;
        this.daySelectId = item.id;
      } else {
        this.searchDayType = null;
        this.daySelectId = -1;
      }
      // 加入搜索
      this.searchMode = 1;
      this.getTbPage();
    },

    // 搜索多选
    earningsMoreSelect(array, index) {
      // 如果为不限，清除其他
      if (index == -1) {
        array = [-1];
      } else {
        if (this.selectContains(array, index)) {
          let position = array.indexOf(index);
          array.splice(position, 1);
        } else {
          array.push(index);
        }
      }
      // 将其存入 selectList中

      // 请求
    },
    // 玩法搜索单选
    playSelect(item) {
      // 选的一级和之前不一样清除二级
      if (
        item.playTypeId == this.playSelectIndex ||
        item == this.playSelectIndex
      ) {
        return;
      }
      this.playSelectIndexList = [-1];
      // 如果为不限，清除二级
      if (item == -1) {
        this.playSelectIndex = item;
        this.playSecondList = [];
      } else {
        console.log(item);
        this.playSelectIndex = item.playTypeId;
        this.playSecondList = item.playList;
      }
      this.searchMode = 1;
      this.getTbPage();
      // let selectParam = new Object();
      // selectParam.type = type;
      // selectParam.name =this.playList[index].name;
      // 请求
    },
    // 处理查询地点（城市，景区，行政区）
    placeChange() {
      let { typeNumber, id } = this.placeSelectIndex;
      // if (typeNumber == 0) {
      //   this.searchRegionId = id;
      // } else if (typeNumber == 1) {
      //   this.searchCityId = id;
      // } else if (typeNumber == 2) {
      //   this.searchScenicSpotsId = id;
      // } else {
      // }
      this.placeClear();
      if (typeNumber == 0) {
        this.searchRegionId = id;
      } else if (typeNumber == 1 || typeNumber == 2 ||  typeNumber == 3) {
        this.searchCityId = id;
      } else {

      }
    },
    // 清理查询地点（城市，景区，行政区）
    placeClear() {
      console.log("placeClear")
      this.searchCityId = null;
      this.searchScenicSpotsId = null;
      this.searchRegionId = null;
    },
    // 判断地点（城市，景区，行政区）是否选中
    placeSelectContain(typeNumberParam, idParam) {
      let { typeNumber, id } = this.placeSelectIndex;
      console.log("-placeSelectContain-");
      console.log(typeNumberParam, idParam);
      console.log(typeNumber, id);
      if (typeNumberParam == typeNumber && idParam == id) {
        return true;
      } else {
        return false;
      }
    },
    // 选择地点
    placeSimpleSelect(typeNumber, id) {
      console.log("-placeSimpleSelect-");
      if (!this.placeSelectContain(typeNumber, id)) {
        this.placeSelectIndex = {
          typeNumber: typeNumber,
          id: id,
        };
      }
      // 处理搜索参数
      this.placeChange();
      // 搜索
      this.searchMode = 1;
      this.getTbPage();
    },
    // 选择地点(无跳转)
    placeSimpleSelect2(typeNumber, id) {
      console.log("-placeSimpleSelect-");
      if (!this.placeSelectContain(typeNumber, id)) {
        this.placeSelectIndex = {
          typeNumber: typeNumber,
          id: id,
        };
      }
      // 处理搜索参数
      this.placeChange();
      // 搜索
      this.searchMode = 1;
    },
    // 玩法搜索多选
    playMoreSelect(item) {

      // 如果为不限，清除其他
      if (item == -1) {
        this.playSelectIndexList = [-1];
        // this.playSecondList = [];
      } else {
        console.log(this.playSelectIndexList);
        if (this.selectContains(this.playSelectIndexList, item.playId)) {
          let position = this.playSelectIndexList.indexOf(item.playId);
          this.playSelectIndexList.splice(position, 1);
          // 当全部都点掉时，补充不限进列表
          if (this.playSelectIndexList.length < 1) {
            this.playSelectIndexList = [-1];
          }
        } else {
          if (this.selectContains(this.playSelectIndexList, -1)) {
            this.playSelectIndexList.splice(0, 1);
          }
          this.playSelectIndexList.push(item.playId);
        }
      }
      // 开始请求
      this.searchMode = 1;
      this.getTbPage();
      return;
    },

    // 收益多选
    profitMoreSelect(item) {
      // 如果为不限，清除其他
      if (!item) {
        this.profitSelectIndexList = [-1];
        // 搜索
        this.searchMode = 1;
        this.getTbPage();
        return;
      }
      console.log(this.profitSelectIndexList);
      if (this.selectContains(this.profitSelectIndexList, item.profitId)) {
        let position = this.profitSelectIndexList.indexOf(item.profitId);
        this.profitSelectIndexList.splice(position, 1);
        // 当全部都点掉时，补充不限进列表
        if (this.profitSelectIndexList.length < 1) {
          this.profitSelectIndexList = [-1];
        }
      } else {
        if (this.selectContains(this.profitSelectIndexList, -1)) {
          this.profitSelectIndexList.splice(0, 1);
        }
        this.profitSelectIndexList.push(item.profitId);
      }
      // 开始请求
      this.searchMode = 1;
      this.getTbPage();
      return;
    },

    // 收益多选(无跳转)
    profitMoreSelect2(item) {
      console.log("profitMoreSelect2")
      // 如果为不限，清除其他
      if (!item) {
        this.profitSelectIndexList = [-1];
        // 搜索
        this.searchMode = 1;
        return;
      }
      console.log(this.profitSelectIndexList);
      if (this.selectContains(this.profitSelectIndexList, item.profitId)) {
        let position = this.profitSelectIndexList.indexOf(item.profitId);
        this.profitSelectIndexList.splice(position, 1);
        // 当全部都点掉时，补充不限进列表
        if (this.profitSelectIndexList.length < 1) {
          this.profitSelectIndexList = [-1];
        }
      } else {
        if (this.selectContains(this.profitSelectIndexList, -1)) {
          this.profitSelectIndexList.splice(0, 1);
        }
        this.profitSelectIndexList.push(item.profitId);
      }
      console.log("this.profitSelectIndexList",this.profitSelectIndexList)
      // 开始请求
      this.searchMode = 1;
      return;
    },

    // 获取团建查询条件
    getTbCondition() {
      axios.get("/api/tb/tbCondition").then((res) => {
        if (res.data && res.data.code == 200) {
          this.playList = res.data.play;
          if (
            this.playSelectIndex != -1 &&
            this.playList &&
            this.playSelectIndexList &&
            this.playSelectIndexList.length > 0 &&
            this.playSelectIndexList[0] != -1
          ) {
            this.playList.forEach((playItem) => {
              if (playItem.playTypeId == this.playSelectIndex) {
                this.playSecondList = playItem.playList;
              }
            });
          }
          this.profitList = res.data.profit;
        }
      });
    },

    // 选择目的地
    selectTargetPlace(index) {
      if (this.targetPlaceNum != index && index == -1) {
        this.targetPlaceNum = index;
        this.placeContentArray = [];
        this.placeClear();
        this.searchMode = 1;
        this.getTbPage();
        // 重新搜索
      } else {
        this.targetPlaceNum = index;
        this.placeContentArray = this.targetPlace[index].child;
      }
    },

    // 查询行政区
    getRegionList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        cityId: cityId,
      };
      axios
        .get(`/api/city/cityRegionList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.regionList = res.data.cityRegionList;
            if (this.regionList) {
              this.regionList.forEach((region) => {
                region.id = region.regionId;
                region.name = region.regionName;
              });
            }
            console.log("--regionList---");
            if (this.targetPlaceNum == 0) {
              this.placeContentArray = this.regionList;
            }
            this.targetPlace[0].child = this.regionList;
            console.log(this.targetPlace[0].child);
          }
        });
    },
    // 查询景区
    getScenicSpotsList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        cityId: cityId,
      };
      axios
        .get(`/api/city/scenicSpotslist`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.scenicSpotsList = res.data.scenicSpotslist;
            if (this.targetPlaceNum == 2) {
              this.placeContentArray = this.scenicSpotsList;
            }
            this.targetPlace[2].child = this.scenicSpotsList;
          }
        });
    },
    // 查询省内城市
    getSurroundCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/surroundCityList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.surroundCityList = res.data.surroundCityList;
            if (this.surroundCityList) {
              this.surroundCityList.forEach((surroundCity) => {
                surroundCity.id = surroundCity.cityId;
                surroundCity.name = surroundCity.cityName;
              });
            }
            if (this.targetPlaceNum == 1) {
              this.placeContentArray = this.surroundCityList;
            }
            this.targetPlace[1].child = this.surroundCityList;
          }
        });
    },
    // 查询国内城市
    getDomesticCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/domesticCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.domesticCityList = res.data.domesticCityList;
            if (this.domesticCityList) {
              this.domesticCityList.forEach((domesticCity) => {
                domesticCity.id = domesticCity.cityId;
                domesticCity.name = domesticCity.cityName;
              });
            }
            if (this.targetPlaceNum == 2) {
              this.placeContentArray = this.domesticCityList;
            }
            this.targetPlace[2].child = this.domesticCityList;
          }
        });
    },
     // 查询国际长线
    getForeignCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/foreignCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.foreignCityList = res.data.foreignCityList;
            if (this.foreignCityList) {
              this.foreignCityList.forEach((foreignCity) => {
                foreignCity.id = foreignCity.cityId;
                foreignCity.name = foreignCity.cityName;
              });
            }
            if (this.targetPlaceNum == 3) {
              this.placeContentArray = this.foreignCityList;
            }
            this.targetPlace[3].child = this.foreignCityList;
          }
        });
    },

      // 微信分享接口调用
  wxShareForTeamBuilding(){
    // 微信分享
    if (wxShare.is_wx()) {
      let url = window.location.href
      if(url.indexOf("teamBuilding?") == -1){
        url += "?";
      }else{
        url = url.split("teamBuilding?")[0]+"teamBuilding?"
      }
      // 补齐链接
      if(this.searchMode == 1){
      let playTypeId = this.playSelectIndex != -1 ? this.playSelectIndex : -1;
      let playIds = "";
      this.playSelectIndexList.forEach((play) => {
        if (play != -1) {
          if (playIds != "") {
            playIds += "," + play;
          } else {
            playIds = play;
          }
        }
      });
      let placeId = "";
      let typeNumber = "";
        if(this.targetPlaceNum == 0){
          placeId = this.searchRegionId;
          typeNumber = -1;
        }else if(this.targetPlaceNum == 1 || this.targetPlaceNum == 2 ||  this.targetPlaceNum == 3){
          placeId = this.searchCityId;
          typeNumber = this.targetPlaceNum;
        }
        let profitIds = "";
      this.profitSelectIndexList.forEach((profit) => {
        if (profit != -1) {
          if (profitIds != "") {
            profitIds += "," + profit;
          } else {
            profitIds = profit;
          }
        }
      });
        url += "&pageNum="+ this.pageNum
        +"&dayType="+this.searchDayType
        +"&profitIds="+profitIds
        +"&typeNumber="+typeNumber
        +"&placeId="+placeId
        +"&playTypeId="+playTypeId
        +"&playId="+ playIds
        +"&priceSort="+this.priceSort
      }else{
      if (this.searchVal) {
        this.tbTypeId = null;
        this.destinationId = null;
      }
      if (this.destinationId) {
        this.tbTypeId = null;
      }
        url += "&pageNum="+ this.pageNum
        +"&search="+this.searchVal
        +"&typeId="+this.tbTypeId
        +"&destinationId="+this.destinationId
        +"&priceSort="+this.priceSort
      }
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${url}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
    // 计算免费定制的显示
    handleScrollx() {
      let contentTopBottom =
        this.$refs.contentTopRef.getBoundingClientRect().bottom;
      let freeBookingBottom =
        this.$refs.freeBookingRef.getBoundingClientRect().bottom;
      let buildingListBottom =
        this.$refs.buildingListRef.getBoundingClientRect().bottom;
      let freeBookingRefHeight = this.$refs.freeBookingRef.offsetHeight;
      // let buildingListSelectionsRefHeight =
      //   this.$refs.buildingListSelectionsRef.offsetHeight;
      let buildingListSortHeight = this.$refs.buildingListSortRef.offsetHeight;
      let condition1 =
        buildingListBottom -
        freeBookingRefHeight -
        // buildingListSelectionsRefHeight -
        buildingListSortHeight -
        60;
      if (condition1 >= 0 && contentTopBottom <= 0) {
        this.freeBookingStyle = 1;
        return;
      } else {
        this.freeBookingStyle = 2;
      }

      // 默认计算触顶位置
      let contentTopRefHeight = this.$refs.contentTopRef.offsetHeight;
      this.topHeight =
        contentTopRefHeight +
        // buildingListSelectionsRefHeight +
        buildingListSortHeight +
        60 +
        "px";
      // 计算触底位置
      console.log(buildingListBottom);
      console.log(freeBookingRefHeight);
      // 数据大于3条才会触发
      if (buildingListBottom - freeBookingRefHeight - 140 < 0) {
        let containerRefHeight = this.$refs.containerRef.offsetHeight;
        this.topHeight = containerRefHeight - freeBookingRefHeight - 60 + "px";
      }
    },
  },

  mounted() {
    this.handleScrollx();
    window.addEventListener("scroll", this.handleScrollx, true);
    this.wxShareForTeamBuilding();
  },


  created() {
    // 是否是文字搜索框的方式搜索
    let isSearchTag = false;
    if (this.$route.query) {
      if (this.$route.query.pageNum) {
        this.pageNum = this.$route.query.pageNum
      }
      if (this.$route.query.search) {
        this.searchMode = 2;
        console.log(this.$route.query.search);
        this.searchVal = this.$route.query.search;
        this.getSearchTbPage();
        isSearchTag = true;
      }
      // 团建类型id
      if (this.$route.query.typeId) {
        this.searchMode = 2;
        this.tbTypeId = this.$route.query.typeId;
        this.getSearchTbPage();
        isSearchTag = true;
      }
      // 团建目的地id
      if (this.$route.query.destinationId) {
        this.searchMode = 2;
        this.destinationId = this.$route.query.destinationId;
        this.getSearchTbPage();
        isSearchTag = true;
      }
      // 团建玩法id
      if (this.$route.query.playTypeId) {
        this.playSelectIndex = this.$route.query.playTypeId;
        if (this.$route.query.playId) {
          let playItem = {};
          if(String(this.$route.query.playId).indexOf(",")==-1){
            playItem = {
              playId: this.$route.query.playId,
            };
            this.playMoreSelect(playItem);
          }else{
            const playIdArray = this.$route.query.playId.split(",") ;
            playIdArray.forEach(playId=>{
              playItem = {
              playId:Number(playId),
            };
            this.playMoreSelect(playItem);
            })
          }
        }
      }
      // 收益
      if (this.$route.query.profitIds) {
        let profitIds = this.$route.query.profitIds;
        let profitIdItem = {};
        const profitIdArray = profitIds.split(",") ;
        profitIdArray.forEach(profitId=>{
          profitIdItem = {
            profitId: Number(profitId),
          };
          this.profitMoreSelect2(profitIdItem)
        })
      }
      // 价格排序
      if (this.$route.query.priceSort) {
        this.priceSort = this.$route.query.priceSort;
        if(this.priceSort!=-1){
          this.selectSort = 2
        }else{
          this.selectSort = 1
        }
      }

      // 天数
      if (this.$route.query.dayType) {
        const dayType = this.$route.query.dayType;
        this.dayList.forEach((item)=>{
           if(item.dayType == dayType){
            this.searchDayType = item.dayType;
            this.daySelectId = item.id;
           }
        })
      }


      // 传入地区
      if (this.$route.query.typeNumber && this.$route.query.placeId) {
        let typeNumber = -1;
        // router无法传输0，只能用-1代替，此处用于将-1转为0
        if (this.$route.query.typeNumber == -1) {
          typeNumber = 0;
        } else [(typeNumber = this.$route.query.typeNumber)];
        this.selectTargetPlace(typeNumber);
        this.placeSimpleSelect2(typeNumber, this.$route.query.placeId);
      }
    }
    // this.getScenicSpotsList();
    this.getSurroundCityList();
    this.getRegionList();
    this.getDomesticCityList();
    this.getForeignCityList();
    this.getTbCondition();
    this.loading = true;
    if (!isSearchTag) {
      this.getTbPage();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>

<style scoped>
.teamBuilding {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
}
.content {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between; */
}
/* 搜索 */
.content-top {
  background-color: #f8f8f8;
  width: 100%;
}
.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: left;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  padding: 20px 20px;
  font-size: 14px;
  padding: 20px 20px;

  /* background: rgba(0, 0, 0, 0.38); */
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #359ff8;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  /* background: #98D9C1; */
}
.search-select-item {
  /* position: relative; */
  padding: 6px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* align-content: center;
    justify-items: center;
    align-items: center; */
}

.search-select-item .select-sider {
  display: block;
  width: 90px;
  padding-left: 30px;
  /* position: relative; */
  left: 23px;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  /* width: fit-content; */
  color: #545658;
  text-align: left;
}
.search-select-item .select-tabs {
  /* margin-left: 50px;
    margin-right: 70px;
    padding-right: 40px; */
  overflow: hidden;
  width: 860px;
  /* position: relative; */
}
.search-select-item .close-open {
  /* height: 30px;
    line-height: 30px;
    text-align: right;
    display: inline-block;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0; */
  font-weight: 700;
  font-size: 12px;
  padding-top: 5px;
  color: #18d3a0;
}
.search-select-item .select-tabs ul {
  list-style: none;
}
.search-select-item .select-tabs ul li {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px 6px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  color: #515255;
  border-radius: 15px;
}
.search-select-item .select-tabs ul .select {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px;
  height: 30px;
  display: inline-block;
  font-weight: 700;
  color: #fff;
  background-color: #359ff8;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  border-radius: 15px;
}
.search-item .select-tabs {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px;
  height: 30px;
  display: inline-block;
  font-weight: 700;
  color: #fff;
  background-color: #359ff8;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  color: #515255;
  border-radius: 15px;
}
.select-items .select-tabs ul .select {
  color: #088dfa !important;
  font-weight: 100 !important;
  background-color: #c2e2fd;
}

/* 列表 */
.building-list {
  width: 746px;
  background-color: #fff;
}
.building-list .building-list-selections {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  padding-top: 10px;
  cursor: pointer;
  margin-bottom: 20px;
}
.building-list .building-list-selections .selection-sider {
  width: 100px;
  padding-left: 20px;
  display: block;
  height: 18px;
  line-height: 18px;
  font-size: 14px;
  color: #222;
  text-align: left;
}
.building-list .building-list-selections .selection-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* justify-content: flex-start;
  align-content: flex-start;   */
}
.building-list .building-list-selections .selection-item ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
}
.building-list .building-list-selections .selection-item ul li {
  cursor: pointer;
  margin: 0 6px 6px 0;
  height: 18px;
  line-height: 16px;
  background: #fff;
  display: inline-block;
  font-size: 12px;
  color: #262522;
  border: 1px solid #515255;
  display: flex;
  flex-direction: row;
}
.building-list .building-list-selections .selection-item ul li .txt {
  padding: 2px 6px;
  height: 18px;
  line-height: 14px;
  display: inline-block;
}
.building-list .building-list-selections .selection-item ul li .remove {
  margin-right: -1px;
  padding: 1px 0 0;
  font-size: 10px;
  background: #515255;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  width: 18px;
}
#sort-result-clear {
  color: #359ff8;
  cursor: pointer;
  margin: 0 6px 6px 0;
  height: 18px;
  line-height: 16px;
  background: #fff;
  display: inline-block;
  font-size: 12px;
  border: none;
}
.building-list .building-list-sort {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  padding-top: 10px;
  cursor: pointer;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 20px;
}
.building-list .building-list-sort ul {
  list-style: none;
}
.building-list .building-list-sort ul li {
  height: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: 14px;
  color: #515255;
  text-align: left;
  width: 100px;
  border-radius: 4px 4px 0 0;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.building-list .building-list-sort ul .select {
  background: #359ff8;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
}
.building-list-content {
  width: 100%;
  min-height: 600px;
}
.building-list-content .building-list-content-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: flex-start;
  padding: 10px 0px;
  cursor: pointer;
}
.building-list-content .building-list-content-item:hover .title {
  color: #359ff8;
}
.building-list-content-item .buiiding-list-left {
  flex: 3;
}
.building-list-content-item .buiiding-list-left img {
  width: 200px;
  height: 163px;
  display: block;
  background: #efefef;
  border-radius: 3px;
  overflow: hidden;
  /* height: 100%; */
  float: left;
  object-fit: cover;
}
.building-list-content-item .buiiding-list-middle {
  display: flex;
  flex-direction: column;
  flex: 5;
  flex-wrap: nowrap;
  align-content: flex-start;
  padding: 10px 40px 10px 0px;
}
.building-list-content-item .buiiding-list-middle div {
  margin-bottom: 10px;
}
.building-list-content-item .buiiding-list-middle .title {
  font-weight: 700;
  font-size: 18px;
  color: #222;
  overflow: hidden;
  /* padding: 0 140px 10px 20px; */
  max-height: 80px;
}

.building-list-content-item .buiiding-list-middle .tags {
  overflow: hidden;
}
.building-list-content-item .buiiding-list-middle .tags span {
  padding: 0 6px;
  background: #f5f5f5;
  border-radius: 2px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  font-size: 12px;
  color: #5a5a5a;
  text-align: center;
  margin-right: 5.8px;
}

.building-list-content-item .buiiding-list-middle .type span {
  color: #5a5a5a;
  font-size: 14px;
  overflow: hidden;
}
.building-list-content-item .buiiding-list-middle .type .separator {
  padding: 0px 5px;
}
.building-list-content-item .buiiding-list-middle .destination {
  color: #5a5a5a;
  font-size: 14px;
  overflow: hidden;
}
.building-list-content-item .buiiding-list-right {
  flex: 2;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
}
.building-list-content-item .buiiding-list-right div {
  /* margin-bottom: 10px; */
}
.building-list-content-item .buiiding-list-right .exponents {
  margin-bottom: 10px;
}
.building-list-content-item .buiiding-list-right .exponent {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.building-list-content-item .buiiding-list-right .exponent .el-icon-dish {
  width: 20px;
  text-align: left;
  color: #18d3a0;
}
.building-list-content-item .buiiding-list-right .exponent i {
  width: 20px;
  text-align: left;
  color: #18d3a0;
}
.building-list-content-item .buiiding-list-right .exponent .el-rate__icon {
  font-size: 12px;
}
.buiiding-list-right .icon {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
}
.buiiding-list-right .price {
  display: inline;
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
}
.buiiding-list-right .price::after {
  content: " 元起/人";
  font-size: 12px;
  color: #666;
}
.buiiding-list-right .avg-price {
  font-size: 12px;
  color: #666;
}
/* 免费定制 */
.free-booking {
  left: auto;
  margin-top: 0px;
  width: 300px;
  cursor: pointer;
  /* bottom: 20px; */
  z-index: 0;
  margin-left: 756px;
  background: #fff;
  border: 2px solid #359ff8;
  border-radius: 3px;   
  display: flex;
  flex-direction: column;
  position: relative;
}
.free-booking-1 {
  position: fixed;
  top: 80px;
}
.free-booking-2 {
  position: absolute;
  /* top: 750px; */
  /* position: relative;
    top: -2100px; */
}
.free-booking .free-booking-header {
  text-align: center;
}
.free-booking .free-booking-header .free-booking-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
  margin: 0 10px;
}
.free-booking .free-booking-header .free-booking-title {
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  color: #222;
  letter-spacing: 1px;
  height: 80px;
  line-height: 80px;
  vertical-align: middle;
}
.free-booking-item {
  position: relative;
  padding: 9px 25px 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 170px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 170px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 105px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.request::before {
  content: "*";
  color: red;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}

.free-booking-item-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 250px;
  height: 100%;
  cursor: pointer;
}
.free-booking-itemimg {
  margin-top: 30px;
  width: 600px;
}
.element-row {
  flex-flow: row wrap;
}

.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  background: #222;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.buiiding-list-right .fa:before {
    font-size: 12px!important;
}
.buiiding-list-right >>>.el-rate__icon{
  font-size: 14px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/teamBuildingView/teamBuilding.vue